import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonExit = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 12,
	viewBox: "0 0 26 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M5.74907 6.67783C7.37305 6.67783 8.68955 5.36133 8.68955 3.73735C8.68955 2.11337 7.37305 0.796875 5.74907 0.796875C4.12509 0.796875 2.80859 2.11337 2.80859 3.73735C2.80859 5.36133 4.12509 6.67783 5.74907 6.67783Z",
			stroke: "#FF6E40",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 11.2015C1 8.93964 2.80952 6.67773 5.75 6.67773C8.69048 6.67773 10.5 8.93964 10.5 11.2015",
			stroke: "#FF6E40",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9999 11.5L15.2368 3.25H24.763L19.9999 11.5Z",
			fill: "#FF6E40"
		})
	]
});
const ForwardRef = forwardRef(SvgPersonExit);
export { ForwardRef as ReactComponent };
